import axios from '@/utils/request.js'

export const companyList = (params) => { // 公司列表
  return axios.post('goods/gas/company/page', params)
}
export const queryIllegalCompanyList = (params) => { // 查询非法企业
  return axios.post('/goods/bGlmIllegalCompany/queryIllegalCompanyList', params)
}
export const addCompanyByIllegal = (params) => { // 修改非法企业
  return axios.post('/goods/gas/company/addCompanyByIllegal', params)
}
export const getCompanyRegionList = (companyId) => { // 获取经营区域
  return axios.post('/goods/gas/company/getCompanyRegionList', { companyId })
}
export const getRegionListByPra = (regionId) => { // 获取子区域
  return axios.post('/goods/gas/company/getRegionListByPra', { regionId })
}
export const isContainOtherRegion = (params) => { // 判断区域是否有包含关系
  return axios.post('/goods/gas/company/isContainOtherRegion', params)
}
export const addCompanyRegion = (params) => { // 添加企业经营区域
  return axios.post('/goods/gas/company/addCompanyRegion', params)
}
export const deleteCompanyRegion = (rid) => { // 删除经营区域
  return axios.post('/goods/gas/company/deleteCompanyRegion', { rid })
}
export const getNoDistributeUserList = (companyId) => { //  查询未分配用户列表
  return axios.post('/goods/bGlmCustomer/getNoDistributeUserList', { companyId })
}
export const getDepartListByCompanyId = (companyId) => { //  查询未分配用户列表
  return axios.post('/goods/gas/department/getDepartListByCompanyId', { companyId })
}
export const distributeUser = (params) => { //  查询未分配用户列表
  return axios.post('/goods/bGlmCustomer/distributeUser', params)
}
export const getCompanyUserList = (params) => { //  查询收回销售组
  return axios.post('/goods/bGlmCustomer/getCompanyUserList', params)
}
export const recoverUser = (params) => { //  回销售组
  return axios.post('/goods/bGlmCustomer/recoverUser', params)
}
